import {
  IntakeFormReviewSource,
  IntakeSummarySource,
  ProviderViewedType,
  TrackingEvents,
} from '@grow-therapy-team/seedling-components';

import { UserType } from '../types';

// These are our event names
export enum SegmentTrackMetricEnum {
  USER_VIEWED = 'User Viewed',
  USER_CLICKED = 'User Clicked',
  FORM_SUBMITTED = 'Form Submitted',
  USER_INPUTTED = 'User Inputted',
  USER_FOCUSED = 'User Focused',
}

// These are our event types
export enum EventTypeEnum {
  ADD_APPOINTMENT_CLICKED = 'Add Appointment Clicked',
  ADMISSION_PROMPT_DISMISSED = 'Admission Prompt Dismissed',
  ADMISSION_PROMPT_VIEWED = 'Admission Prompt Viewed',
  BROWSER_LANG_NOTICE_MODAL_KEEP = 'Browser Lang Notice Modal Keep',
  BROWSER_LANG_NOTICE_MODAL_SWITCH = 'Browser Lang Notice Modal Switch',
  BROWSER_LANG_NOTICE_MODAL_VIEWED = 'Browser Lang Notice Modal Viewed',
  CLICK_RECORDING_TOGGLE = 'Recording toggle clicked',
  CLIENT_INFO = 'Client Info',
  CLIENT_MEASURES_AUTO_OPENED = 'Client Measures Auto Opened',
  CLIENT_MEASURES_CLICKED = 'Client Measures Clicked',
  CLIENT_MEASURES_STARTED = 'Client Measures Started',
  CLIENT_NEW_INTRO_ROOM_VIEWED = 'Client New Intro Room Viewed',
  CLIENT_NEW_INTRO_ROOM_PII_VERIFICATION_VIEWED = 'Client New Intro Room PII Verification Viewed',
  CLIENT_NEW_INTRO_ROOM_PII_VERIFICATION_SUBMITTED = 'Client New Intro Room PII Verification Submitted',
  CLIENT_NEW_INTRO_ROOM_REQUIRED_AGREEMENTS_REVIEW_VIEWED = 'Client New Intro Room Required Agreements Review Viewed',
  CLIENT_NEW_INTRO_ROOM_REQUIRED_AGREEMENTS_SIGNED = 'Client New Intro Room Required Agreements Signed',
  JOIN_SESSION_ERROR = 'Join Session Error',
  JOINED_SESSION = 'Joined Session',
  CLIENT_JOINING_SESSION_LOADER_VIEWED = 'Client Joining Session Loader Viewed',
  CLIENT_WAITING_ROOM = 'Telehealth Client Waiting Room',
  CSSRS_PROMPT_TOAST_SHOWN = 'CSSRS Prompt Toast Shown',
  FIVE_MINUTE_REMINDER_TOAST_SCHEDULING_PROMPT = '5 Minute Reminder Toast Scheduling Prompt',
  TELEHEALTH_REBOOKING_NUDGE_SHOWN = 'Telehealth Rebooking Nudge Shown',
  TELEHEALTH_REBOOKING_NUDGE_CLICKED = 'Telehealth Rebooking Nudge Clicked',
  TELEHEALTH_REBOOKING_NUDGE_DISMISSED = 'Telehealth Rebooking Nudge Dismissed',
  GAVE_TRANSCRIPTION_CONSENT = 'User Consented to Transcription',
  JOIN_SESSION_CLICKED = 'Join Session Clicked',
  PROVIDER_ADMIT_CLIENT = 'Provider Admit Client',
  LANGUAGE_SWITCHER_MODAL_SAVE = 'Language Switcher Modal Save',
  LANGUAGE_SWITCHER_MODAL_TRIGGER = 'Language Switcher Modal Trigger',
  LINK_CLICKED = 'Link Clicked',
  NAVIGATION_GUARD_TRIGGERED = 'Session Navigation Guard Triggered',
  LOGIN_ERROR_PAGE_VIEWED = 'Login Redirect Error Page Viewed',
  MEASURE_PROGRESS_CLICKED = 'Measure Progress Clicked',
  MEASURE_PROGRESS_VIEWED = 'Measure Progress Viewed',
  MEASURES_LIST_ITEM_CLICKED = 'Measures List Item Clicked',
  MEASURE_RESPONSES_DRAWER_VIEWED = 'Measure Responses Drawer Viewed',
  MEASURE_VIEWED = 'Telehealth Measure Viewed',
  PRE_SESSION_VIBES = 'Pre Session Vibes',
  PREFERRED_LANGUAGE_MODAL_VIEWED = 'Preferred Language Modal Viewed',
  PROVIDER_END_WHITEBOARD = 'Provider End Whiteboard',
  PROVIDER_NUDGE_CLICKED = 'Provider Nudge Clicked',
  PROVIDER_PRE_SESSION_PREP_BUTTON_CLICKED = 'Pre-Session Prep Button Clicked',
  PROVIDER_SESSION_COMPLETE = 'Provider Completed Session',
  PROVIDER_SESSION_EARLY_END_COMPLETE = 'Provider Ended Session Early (Complete)',
  PROVIDER_SESSION_EARLY_END_RESTART = 'Provider Ended Session Early (Restart)',
  PROVIDER_START_WHITEBOARD = 'Provider Start Whiteboard',
  PROVIDER_WAITING_ROOM = 'Telehealth Provider Waiting Room',
  RECONNECTED_REMOTE_PARTICIPANT_VIEWED = 'Reconnected Remote Participant Viewed',
  RECONNECTING_REMOTE_PARTICIPANT_VIEWED = 'Reconnecting Remote Participant Viewed',
  REFLECTION_TOPICS_VIEWED = 'Reflection Topics Viewed',
  REJOIN_SESSION_CLICKED = 'Rejoin Session Clicked',
  REJOIN_SESSION_PROMPT_VIEWED = 'Rejoin Session Prompt Viewed',
  RETRY_LOGIN_CLICKED = 'Retry Login Clicked',
  SCHEDULE_TAB = 'Schedule Tab',
  SCRIBBLE_ACCESSED = 'Scribble (Patient Note) Accessed',
  SCRIBBLE_EDITED = 'Scribble (Patient Note) Edited',
  SESSION_ENDING_SOON_BANNER_VIEWED = 'Session Ending Soon Banner Viewed',
  SESSION_PARTICIPANT_VIEWED = 'Session Participant Viewed',
  TREATMENT_TAB = 'Treatment Tab',
  VIDEO_PLATFORM_COMPATIBILITY_WARNING_VIEWED = 'Video Platform Compatibility Warning Viewed',
  WAITING_ROOM_APPOINTMENT_CREATED = 'Waiting Room Appointment Created',
  WAITING_ROOM_APPOINTMENT_UPDATED = 'Waiting Room Appointment Updated',
  INTAKE_FORM_RESPONSE_REVIEWED = ProviderViewedType.INTAKE_FORM_RESPONSE_REVIEWED,
  INTAKE_SUMMARY_REVIEWED = ProviderViewedType.INTAKE_SUMMARY_REVIEWED,
  INTAKE_SUMMARY_VIEW_FULL_INTAKE_CLICKED = TrackingEvents.INTAKE_SUMMARY_VIEW_FULL_INTAKE_CLICKED,
  CLIENT_CLICKED_PROVIDER_INTENTION_VIEW = 'Client Clicked Provider Intention View',
  INTENTION_SETTING_PILL_CLICKED = 'Intention Setting Pill Clicked',
  INTENTION_SETTING_PILL_VIEWED = 'Intention Setting Pill Viewed',
  INTENTION_MODULE_OPEN_BUTTON_CLICKED = 'Intention module open button clicked',
  INTENTION_MODULE_VIEWED = 'Intention module viewed',
  INTENTION_EDITING_STARTED = 'Intention editing started',
  INTENTION_SUBMITTED = 'Intention submitted',
  INTERSESSION_SECTION_TOGGLED = 'Intersession Section Toggled',
  INTERSESSION_SUMMARY_VIEWED = 'Intersession Summary Viewed',
  INTERSESSION_VIEW_MEASURES_BUTTON_CLICKED = 'Intersession View Measures Button Clicked',
  NUDGE_LIST_VIEWED = 'Nudge List Viewed',
  SAFETY_CONCERN_CONVERSATION_CLICKED = 'Safety Concern Conversation Clicked',
  WAITING_ROOM_SCHEDULE = 'Waiting Room Schedule',
  SOFT_BLOCK_ELIGIBILITY_EVALUATED = 'Soft Block Eligibility Evaluated',
  SOFT_BLOCK_GET_STARTED_VIEWED = 'Soft Block Get Started Viewed',
  SOFT_BLOCK_GET_STARTED_CLICKED = 'Soft Block Get Started Clicked',
  SOFT_BLOCK_MEASURE_VIEWED = 'Soft Block Measure Viewed',
  SOFT_BLOCK_MEASURE_COMPLETED = 'Soft Block Measure Completed',
  SOFT_BLOCK_MEASURE_SKIPPED = 'Soft Block Measure Skipped',
  SOFT_BLOCK_GUARDRAIL_PROMPT_SHOWN = 'Soft Block Guardrail Prompt Shown',
  SOFT_BLOCK_AUTO_TRANSITIONED = 'Soft Block Auto Transitioned',
  SYSTEM_NOTIFICATION_FOR_ADMISSION_VIEWED = 'System Notification For Admission Viewed',
  SYSTEM_NOTIFICATION_FOR_ADMISSION_CLICKED = 'System Notification For Admission Clicked',
  SYSTEM_NOTIFICATIONS_PERMISSION_SOFT_PROMPT_VIEWED = 'System Notifications Permission Soft Prompt Viewed',
  SYSTEM_NOTIFICATIONS_PERMISSION_SOFT_PROMPT_DISMISSED = 'System Notifications Permission Soft Prompt Dismissed',
  SYSTEM_NOTIFICATIONS_PERMISSION_ALLOWED = 'System Notifications Permission Allowed',
  SYSTEM_NOTIFICATIONS_PERMISSION_DENIED = 'System Notifications Permission Denied',
  PROVIDER_INTAKE_SUMMARY_ALLOCATION_RECORDED = 'Provider Intake Summary Allocation Recorded',
  PROVIDER_INTAKE_SUMMARY_EXPERIMENT_STAGE_VIEWED = 'Provider Intake Summary Experiment Stage Viewed',
}

export type MeasureResponsesEntryMethod =
  | 'measures_list_item'
  | 'progress_table_row'
  | 'auto_opened_post_admission'
  | 'pre_session_prep_button';

export type ClientInfoEntryPoint = 'queue_menu' | 'in_session_control_button' | 'overflow_menu';

export type MeasureBundleCompletionState = 'completed' | 'partially_completed' | 'incomplete';

export type TrackParams = {
  cta: string;
  patientShortId: string;
  providerShortId: string;
  numberOfAppointments: number;
  scheduleError: boolean;
  appointmentPosition: number;
  appointmentStatus: 'RESCHEDULED' | 'CANCELLED';
  appointmentShortId: string;
  appointmentTimeStart: string;
  newRecordingStatus: 'PLAY' | 'PAUSE';
  entityType: UserType;
  entityShortId: string;
  type: string;
  measureProgressView: 'table' | 'graph';
  inSession?: boolean;
  measureBundleShortId: string;
  measureResponseShortId: string | null;
  measureSchemaType: string | null;
  scoreCategoryLabel: string | null;
  displayScore: number | null;
  hasCssrsAlert: boolean;
  previousMeasureBundleShortId: string;
  entryMethod: MeasureResponsesEntryMethod;
  isViewingUpcomingClient?: boolean;
  hasCompletedMeasureResponses: boolean;
  hasHighAcuityFlag: boolean;
  hasMeasureBundles: boolean;
  bundleCompletionState: MeasureBundleCompletionState;
  entryPoint: ClientInfoEntryPoint;
  measureSchemaTypesPresent: string[];
  scoreCategoryLabelsPresent: string[];
  nudgeId: number;
  duration: number;
  editedLength: number;
  formResponseId: number;
  paragraphCount: number;
  flowId: string;
  isClientUserAuthenticated: boolean;
  /**
   * Whether the user had completed the app's authentication flow at the time
   * the event fired.
   */
  isAuthenticated: boolean;
  isVerified: boolean;
  /**
   * Generic frontend transaction id (e.g. for admission, join, etc.).
   */
  txId: string;
  /**
   * Identifier for the subject of an event (e.g. the parsed id of a remote
   * video-SDK participant). Distinct from Segment's reserved top-level
   * `userId` to avoid warehouse column collisions.
   */
  entityId: string;
  /**
   * Often used to specify the video platform e.g. `zoom` or `twilio`
   */
  source: string;
  errorCode: string;
  /**
   * Used for localization tracking
   */
  current: string;
  previous: string;
  suggested: string;
  navigationGuardTrigger: 'in_app' | 'beforeunload';
  navigationGuardOutcome: 'stay' | 'leave';
  outstandingMeasureTypes: string[];
  hasOutstandingMeasures: boolean;
  sectionName: 'last_session' | 'client_activity' | 'measures';
  isExpanded: boolean;
  conversationUuid: string;
  /**
   * Soft-block (pre-session measures) tracking fields.
   */
  isEligible: boolean;
  isServerEligible: boolean;
  hasStaleMeasures: boolean;
  staleMeasureTypes: string[];
  experiencedHardBlock: boolean;
  isWithinAgeThreshold: boolean;
  /** Whether the client is excluded from soft block by payor (e.g. KPNC). */
  isPayorExcluded: boolean;
  wasAlreadyResolved: boolean;
  /** The `MeasureSchemaType` of the soft-block measure the event relates to. */
  measureType: string;
  /** Which soft-block page the client was on: `get_started` or a measure type. */
  softBlockStep: string;
  /**
   * The name of the page/component the user is on when the event fires,
   * e.g. `waiting_room_page`.
   */
  componentName: string;
  /** The type of the component; for page-level events this is always `page`. */
  componentType: string;
  /** ISO timestamp used when recording experiment allocation anchors. */
  startedAt: string;
  /** Experiment allocation value (e.g. `"true"` / `"false"`). */
  experimentGroup: string;
  /** Generic status string (e.g. delayed-experiment stage id). */
  status: string;
  /** Whether the client already has a follow-up appointment scheduled after the current session. */
  hasFutureAppointment: boolean;
  /** The appointment/session type for rebooking nudge events (e.g. `intake`). */
  sessionType: string;
  /** Which CTA the provider clicked on a rebooking nudge (e.g. `schedule`, `view_appointment`). */
  ctaType: string;
};
export type LoginErrorPageParams = Pick<TrackParams, 'source' | 'errorCode' | 'entityType'> &
  Partial<Pick<TrackParams, 'patientShortId' | 'providerShortId'>>;

export type NavigationGuardTriggeredParams = Pick<TrackParams, 'navigationGuardTrigger'> &
  Partial<Pick<TrackParams, 'navigationGuardOutcome'>>;

export type ClientInfoParams = Pick<TrackParams, 'patientShortId'> &
  Partial<
    Pick<
      TrackParams,
      | 'inSession'
      | 'isViewingUpcomingClient'
      | 'hasCompletedMeasureResponses'
      | 'hasHighAcuityFlag'
      | 'entryPoint'
      | 'hasMeasureBundles'
      | 'bundleCompletionState'
    >
  >;

export type TreatmentTabViewedParams = Pick<TrackParams, 'patientShortId'> &
  Partial<Pick<TrackParams, 'inSession' | 'isViewingUpcomingClient' | 'hasCompletedMeasureResponses'>>;

export type MeasuresListItemClickedParams = Pick<
  TrackParams,
  'patientShortId' | 'providerShortId' | 'bundleCompletionState' | 'inSession'
> &
  Partial<Pick<TrackParams, 'measureBundleShortId' | 'appointmentShortId'>>;
export type WaitingRoomAppointmentUpdatedParams = Pick<
  TrackParams,
  'patientShortId' | 'appointmentShortId' | 'appointmentStatus'
>;

export type WaitingRoomAppointmentCreatedParams = Pick<TrackParams, 'patientShortId' | 'appointmentShortId'>;

export type VideoPlatformCompatibilityWarningViewedParams = Pick<
  TrackParams,
  'providerShortId' | 'patientShortId' | 'source'
> &
  Partial<Pick<TrackParams, 'appointmentShortId'>>;

export type WaitingRoomScheduleViewParams = Pick<TrackParams, 'numberOfAppointments' | 'scheduleError'>;
export type WaitingRoomScheduleClickParams = Pick<TrackParams, 'appointmentPosition' | 'appointmentShortId'>;
export type WaitingRoomViewParams = Pick<
  TrackParams,
  'appointmentShortId' | 'appointmentTimeStart' | 'isAuthenticated'
>;

export type MeasureViewedParams = Pick<TrackParams, 'type'>;

export type RecordingToggleClickedParams = Pick<
  TrackParams,
  'appointmentShortId' | 'newRecordingStatus' | 'entityType'
>;

export type TranscriptionConsentClickedParams = Pick<TrackParams, 'appointmentShortId' | 'entityType'>;

export type MeasureProgressClickedParams = Pick<
  TrackParams,
  'measureProgressView' | 'inSession' | 'patientShortId' | 'providerShortId'
> &
  Partial<
    Pick<TrackParams, 'appointmentShortId' | 'measureResponseShortId' | 'measureSchemaType' | 'scoreCategoryLabel'>
  >;

export type MeasureProgressViewedParams = Pick<
  TrackParams,
  | 'measureProgressView'
  | 'inSession'
  | 'patientShortId'
  | 'providerShortId'
  | 'measureSchemaTypesPresent'
  | 'scoreCategoryLabelsPresent'
> &
  Partial<Pick<TrackParams, 'appointmentShortId'>>;

export type MeasureResponsesDrawerViewedParams = Pick<
  TrackParams,
  | 'patientShortId'
  | 'providerShortId'
  | 'measureBundleShortId'
  | 'measureResponseShortId'
  | 'measureSchemaType'
  | 'scoreCategoryLabel'
  | 'displayScore'
  | 'inSession'
  | 'hasCssrsAlert'
> &
  Partial<Pick<TrackParams, 'appointmentShortId' | 'previousMeasureBundleShortId' | 'entryMethod'>>;

export type PreSessionVibesViewedParams = Pick<
  TrackParams,
  'patientShortId' | 'providerShortId' | 'appointmentShortId'
>;

export type WhiteboardParams = Pick<TrackParams, 'appointmentShortId'>;

export type ProviderNudgeClickedParams = Pick<TrackParams, 'nudgeId'> &
  Partial<Pick<TrackParams, 'appointmentShortId' | 'source'>>;

export type ProviderPreSessionPrepButtonClickedParams = Pick<
  TrackParams,
  'cta' | 'appointmentShortId' | 'providerShortId' | 'inSession'
>;

export type ReflectionTopicsViewedParams = Pick<TrackParams, 'patientShortId' | 'inSession'>;

export type ScribbleAccessedParams =
  | Pick<TrackParams, 'patientShortId' | 'appointmentShortId' | 'inSession'>
  | Pick<TrackParams, 'patientShortId'>;

export type ScribbleEditedParams = ScribbleAccessedParams & Pick<TrackParams, 'editedLength' | 'paragraphCount'>;

export type LinkClickedParams = Pick<TrackParams, 'cta'>;

export type EndSessionParams = Pick<TrackParams, 'appointmentShortId'>;
export type FiveMinuteReminderToastParams = Pick<TrackParams, 'patientShortId' | 'providerShortId'>;

export type TelehealthRebookingNudgeParams = Pick<
  TrackParams,
  'appointmentShortId' | 'patientShortId' | 'providerShortId' | 'experimentGroup'
> & {
  sessionType: 'intake';
  hasFutureAppointment: boolean;
};

export type TelehealthRebookingNudgeClickedParams = TelehealthRebookingNudgeParams &
  Pick<TrackParams, 'ctaType'> & {
    ctaType: 'schedule' | 'view_appointment';
  };

export type CSSRSPromptToastShownParams = Pick<TrackParams, 'patientShortId' | 'providerShortId'> &
  Partial<Pick<TrackParams, 'appointmentShortId'>> & {
    triggerSource?: string;
    cssrsType?: string;
  };

/**
 * Patient end-of-session nudge toast (`LeaveSessionNudgeToast`).
 * `variant` matches `SessionRecapBannerVariant`:
 * - `legacy`: pre-Momentum Grow Tip copy
 * - `recap`: Momentum pilot + session recaps enabled
 * - `noRecap`: Momentum pilot + opted out of session recaps
 */
export type SessionEndingSoonBannerViewedParams = Pick<
  TrackParams,
  'appointmentShortId' | 'patientShortId' | 'providerShortId'
> & {
  variant: 'legacy' | 'recap' | 'noRecap';
};

export type IntakeSummaryAllocationRecordedParams = Pick<TrackParams, 'startedAt' | 'experimentGroup'>;

export type IntakeSummaryExperimentStageViewedParams = Pick<TrackParams, 'status'>;

export type IntakeSummaryReviewedParams = Pick<TrackParams, 'duration'> & {
  source: IntakeSummarySource;
} & Partial<Pick<TrackParams, 'appointmentShortId' | 'formResponseId'>>;

export type IntakeSummaryViewFullIntakeClickedParams = {
  source: IntakeSummarySource;
} & Partial<Pick<TrackParams, 'appointmentShortId'>>;

export type AdmissionPromptViewedParams = Pick<
  TrackParams,
  'patientShortId' | 'providerShortId' | 'appointmentShortId' | 'txId'
>;

export type AdmissionPromptDismissedParams = Pick<
  TrackParams,
  'patientShortId' | 'providerShortId' | 'appointmentShortId' | 'txId'
>;

export type JoinSessionClickedParams = Pick<
  TrackParams,
  'patientShortId' | 'providerShortId' | 'appointmentShortId' | 'isClientUserAuthenticated' | 'source' | 'txId'
>;

export type ProviderAdmitClientParams = Pick<
  TrackParams,
  'patientShortId' | 'providerShortId' | 'appointmentShortId' | 'source' | 'txId'
>;

export type JoinedSessionParams = Pick<
  TrackParams,
  'patientShortId' | 'providerShortId' | 'appointmentShortId' | 'source' | 'txId'
> &
  // Only the client side emits this; providers are always authenticated.
  Partial<Pick<TrackParams, 'isAuthenticated'>>;

export type JoinSessionErrorParams = Pick<
  TrackParams,
  'patientShortId' | 'providerShortId' | 'appointmentShortId' | 'source' | 'txId' | 'errorCode'
>;

export type ClientJoiningSessionLoaderViewedParams = Pick<
  TrackParams,
  'patientShortId' | 'providerShortId' | 'appointmentShortId' | 'source' | 'txId'
>;

export type SessionParticipantViewedParams = Pick<
  TrackParams,
  'patientShortId' | 'providerShortId' | 'appointmentShortId' | 'source' | 'entityId' | 'entityType'
> & {
  txId?: string;
};

export type ClientNewIntroRoomBaseParams = Pick<
  TrackParams,
  'patientShortId' | 'providerShortId' | 'appointmentShortId' | 'flowId'
>;

export type ClientNewIntroRoomParams = ClientNewIntroRoomBaseParams & Pick<TrackParams, 'isVerified'>;

export type ClientNewIntroRoomPIIVerificationViewedParams = ClientNewIntroRoomBaseParams &
  Pick<TrackParams, 'isClientUserAuthenticated'>;

export type ReconnectingRemoteParticipantViewedParams = Partial<
  Pick<TrackParams, 'appointmentShortId' | 'patientShortId' | 'providerShortId' | 'source'>
>;

type RejoinSessionBaseParams = Pick<TrackParams, 'appointmentShortId' | 'source'>;

export type RejoinSessionPromptViewedParams = RejoinSessionBaseParams;

export type RejoinSessionClickedParams = RejoinSessionBaseParams & Pick<TrackParams, 'errorCode'>;

export type AddAppointmentClickedParams = Pick<TrackParams, 'patientShortId' | 'providerShortId'>;

export type ClientMeasuresParams = Pick<TrackParams, 'patientShortId' | 'outstandingMeasureTypes'>;

export type ClientClickedProviderIntentionViewParams = Pick<TrackParams, 'appointmentShortId'> & {
  sessionIntentionShortId: string;
  trigger: 'intention_set' | 'intention_edited';
};

export type IntentionSettingPillClickedParams = Pick<TrackParams, 'appointmentShortId'> & {
  intentionState: string;
};

export type IntentionSettingPillViewedParams = Pick<TrackParams, 'appointmentShortId'>;

export type IntentionModuleOpenButtonClickedParams = Pick<TrackParams, 'appointmentShortId'>;

export type IntentionModuleViewedParams = Pick<TrackParams, 'appointmentShortId'> & {
  isClientUserAuthenticated: boolean;
  intentionStatus?: 'new' | 'existing';
};

export type IntentionSavedParams = Pick<TrackParams, 'appointmentShortId'>;

export type IntentionEditingStartedParams = Pick<TrackParams, 'appointmentShortId'>;

export type IntentionSubmittedParams = Pick<TrackParams, 'appointmentShortId'>;

export type IntersessionMeasuresContextParams = Pick<
  TrackParams,
  | 'appointmentShortId'
  | 'patientShortId'
  | 'providerShortId'
  | 'hasCompletedMeasureResponses'
  | 'hasOutstandingMeasures'
>;

export type IntersessionSummaryViewedParams = IntersessionMeasuresContextParams;

export type IntersessionSectionToggledParams = IntersessionMeasuresContextParams &
  Pick<TrackParams, 'sectionName' | 'isExpanded'>;

export type IntersessionViewMeasuresButtonClickedParams = IntersessionMeasuresContextParams;

export type NudgeListViewedParams = Pick<TrackParams, 'appointmentShortId' | 'source'>;

export type SafetyConcernConversationClickedParams = Pick<
  TrackParams,
  'appointmentShortId' | 'source' | 'conversationUuid'
>;

export type SoftBlockBaseParams = Partial<Pick<TrackParams, 'patientShortId' | 'providerShortId'>>;

export type SoftBlockEligibilityEvaluatedParams = SoftBlockBaseParams &
  Pick<
    TrackParams,
    | 'isEligible'
    | 'isServerEligible'
    | 'isAuthenticated'
    | 'hasStaleMeasures'
    | 'staleMeasureTypes'
    | 'experiencedHardBlock'
    | 'isWithinAgeThreshold'
    | 'isPayorExcluded'
    | 'wasAlreadyResolved'
  >;

export type SoftBlockMeasureParams = SoftBlockBaseParams & Pick<TrackParams, 'measureType'>;

export type SoftBlockGuardrailParams = SoftBlockBaseParams & Pick<TrackParams, 'softBlockStep'>;

export type SystemNotificationForAdmissionParams = Pick<
  TrackParams,
  'source' | 'patientShortId' | 'providerShortId' | 'componentName' | 'componentType'
> &
  Partial<Pick<TrackParams, 'appointmentShortId' | 'txId'>>;

export type SystemNotificationsPermissionParams = Omit<SystemNotificationForAdmissionParams, 'txId'>;

export type EventToViewParamsMap = {
  [EventTypeEnum.NAVIGATION_GUARD_TRIGGERED]: NavigationGuardTriggeredParams;
  [EventTypeEnum.CLIENT_INFO]: ClientInfoParams;
  [EventTypeEnum.TREATMENT_TAB]: TreatmentTabViewedParams;
  [EventTypeEnum.VIDEO_PLATFORM_COMPATIBILITY_WARNING_VIEWED]: VideoPlatformCompatibilityWarningViewedParams;
  [EventTypeEnum.WAITING_ROOM_SCHEDULE]: WaitingRoomScheduleViewParams;
  [EventTypeEnum.CLIENT_WAITING_ROOM]: WaitingRoomViewParams;
  [EventTypeEnum.PROVIDER_WAITING_ROOM]: WaitingRoomViewParams;
  [EventTypeEnum.LOGIN_ERROR_PAGE_VIEWED]: LoginErrorPageParams;
  [EventTypeEnum.MEASURE_VIEWED]: MeasureViewedParams;
  [EventTypeEnum.MEASURE_PROGRESS_VIEWED]: MeasureProgressViewedParams;
  [EventTypeEnum.MEASURE_RESPONSES_DRAWER_VIEWED]: MeasureResponsesDrawerViewedParams;
  [EventTypeEnum.PRE_SESSION_VIBES]: PreSessionVibesViewedParams;
  [EventTypeEnum.SCRIBBLE_ACCESSED]: ScribbleAccessedParams;
  [EventTypeEnum.REFLECTION_TOPICS_VIEWED]: ReflectionTopicsViewedParams;
  [EventTypeEnum.CLIENT_MEASURES_AUTO_OPENED]: ClientMeasuresParams;
  [EventTypeEnum.ADMISSION_PROMPT_VIEWED]: AdmissionPromptViewedParams;
  [EventTypeEnum.JOIN_SESSION_ERROR]: JoinSessionErrorParams;
  [EventTypeEnum.JOINED_SESSION]: JoinedSessionParams;
  [EventTypeEnum.CLIENT_JOINING_SESSION_LOADER_VIEWED]: ClientJoiningSessionLoaderViewedParams;
  [EventTypeEnum.SESSION_PARTICIPANT_VIEWED]: SessionParticipantViewedParams;
  [EventTypeEnum.CLIENT_NEW_INTRO_ROOM_VIEWED]: ClientNewIntroRoomParams;
  [EventTypeEnum.CLIENT_NEW_INTRO_ROOM_PII_VERIFICATION_VIEWED]: ClientNewIntroRoomBaseParams;
  [EventTypeEnum.CLIENT_NEW_INTRO_ROOM_REQUIRED_AGREEMENTS_REVIEW_VIEWED]: ClientNewIntroRoomPIIVerificationViewedParams;
  [EventTypeEnum.RECONNECTED_REMOTE_PARTICIPANT_VIEWED]: ReconnectingRemoteParticipantViewedParams;
  [EventTypeEnum.RECONNECTING_REMOTE_PARTICIPANT_VIEWED]: ReconnectingRemoteParticipantViewedParams;
  [EventTypeEnum.REJOIN_SESSION_PROMPT_VIEWED]: RejoinSessionPromptViewedParams;
  [EventTypeEnum.BROWSER_LANG_NOTICE_MODAL_VIEWED]: Pick<TrackParams, 'suggested'>;
  [EventTypeEnum.PREFERRED_LANGUAGE_MODAL_VIEWED]: Pick<TrackParams, 'current'>;
  [EventTypeEnum.INTAKE_FORM_RESPONSE_REVIEWED]: {
    formResponseId?: number;
    duration: number;
    source: IntakeFormReviewSource;
  };
  [EventTypeEnum.INTAKE_SUMMARY_REVIEWED]: IntakeSummaryReviewedParams;
  [EventTypeEnum.INTENTION_SETTING_PILL_VIEWED]: IntentionSettingPillViewedParams;
  [EventTypeEnum.INTENTION_MODULE_VIEWED]: IntentionModuleViewedParams;
  [EventTypeEnum.INTERSESSION_SUMMARY_VIEWED]: IntersessionSummaryViewedParams;
  [EventTypeEnum.NUDGE_LIST_VIEWED]: NudgeListViewedParams;
  [EventTypeEnum.SOFT_BLOCK_GET_STARTED_VIEWED]: SoftBlockBaseParams;
  [EventTypeEnum.SOFT_BLOCK_MEASURE_VIEWED]: SoftBlockMeasureParams;
  [EventTypeEnum.SOFT_BLOCK_GUARDRAIL_PROMPT_SHOWN]: SoftBlockGuardrailParams;
  [EventTypeEnum.SYSTEM_NOTIFICATION_FOR_ADMISSION_VIEWED]: SystemNotificationForAdmissionParams;
  [EventTypeEnum.SYSTEM_NOTIFICATIONS_PERMISSION_SOFT_PROMPT_VIEWED]: SystemNotificationsPermissionParams;
  [EventTypeEnum.SESSION_ENDING_SOON_BANNER_VIEWED]: SessionEndingSoonBannerViewedParams;
  [EventTypeEnum.PROVIDER_INTAKE_SUMMARY_EXPERIMENT_STAGE_VIEWED]: IntakeSummaryExperimentStageViewedParams;
  [EventTypeEnum.TELEHEALTH_REBOOKING_NUDGE_SHOWN]: TelehealthRebookingNudgeParams;
  [EventTypeEnum.CSSRS_PROMPT_TOAST_SHOWN]: CSSRSPromptToastShownParams;
};

export type UserViewedParams<P extends EventTypeEnum> = {
  componentName?: string;
  componentType?: string;
} & (P extends keyof EventToViewParamsMap ? EventToViewParamsMap[P] : never);

export type EventToClickParamsMap = {
  [EventTypeEnum.ADD_APPOINTMENT_CLICKED]: AddAppointmentClickedParams;
  [EventTypeEnum.WAITING_ROOM_SCHEDULE]: WaitingRoomScheduleClickParams;
  [EventTypeEnum.CLIENT_INFO]: ClientInfoParams;
  [EventTypeEnum.MEASURES_LIST_ITEM_CLICKED]: MeasuresListItemClickedParams;
  [EventTypeEnum.CLIENT_MEASURES_CLICKED]: ClientMeasuresParams;
  [EventTypeEnum.CLICK_RECORDING_TOGGLE]: RecordingToggleClickedParams;
  [EventTypeEnum.GAVE_TRANSCRIPTION_CONSENT]: TranscriptionConsentClickedParams;
  [EventTypeEnum.MEASURE_PROGRESS_CLICKED]: MeasureProgressClickedParams;
  [EventTypeEnum.PROVIDER_NUDGE_CLICKED]: ProviderNudgeClickedParams;
  [EventTypeEnum.PROVIDER_PRE_SESSION_PREP_BUTTON_CLICKED]: ProviderPreSessionPrepButtonClickedParams;
  [EventTypeEnum.INTAKE_SUMMARY_VIEW_FULL_INTAKE_CLICKED]: IntakeSummaryViewFullIntakeClickedParams;
  [EventTypeEnum.PROVIDER_START_WHITEBOARD]: WhiteboardParams;
  [EventTypeEnum.PROVIDER_END_WHITEBOARD]: WhiteboardParams;
  [EventTypeEnum.LINK_CLICKED]: LinkClickedParams;
  [EventTypeEnum.PROVIDER_SESSION_EARLY_END_COMPLETE]: EndSessionParams;
  [EventTypeEnum.PROVIDER_SESSION_EARLY_END_RESTART]: EndSessionParams;
  [EventTypeEnum.PROVIDER_SESSION_COMPLETE]: EndSessionParams;
  [EventTypeEnum.FIVE_MINUTE_REMINDER_TOAST_SCHEDULING_PROMPT]: FiveMinuteReminderToastParams;
  [EventTypeEnum.TELEHEALTH_REBOOKING_NUDGE_CLICKED]: TelehealthRebookingNudgeClickedParams;
  [EventTypeEnum.TELEHEALTH_REBOOKING_NUDGE_DISMISSED]: TelehealthRebookingNudgeParams;
  [EventTypeEnum.JOIN_SESSION_CLICKED]: JoinSessionClickedParams;
  [EventTypeEnum.PROVIDER_ADMIT_CLIENT]: ProviderAdmitClientParams;
  [EventTypeEnum.ADMISSION_PROMPT_DISMISSED]: AdmissionPromptDismissedParams;
  [EventTypeEnum.RETRY_LOGIN_CLICKED]: LoginErrorPageParams;
  [EventTypeEnum.REJOIN_SESSION_CLICKED]: RejoinSessionClickedParams;
  [EventTypeEnum.LANGUAGE_SWITCHER_MODAL_TRIGGER]: Pick<TrackParams, 'current'>;
  [EventTypeEnum.LANGUAGE_SWITCHER_MODAL_SAVE]: Pick<TrackParams, 'previous' | 'current'>;
  [EventTypeEnum.BROWSER_LANG_NOTICE_MODAL_SWITCH]: Pick<TrackParams, 'previous' | 'current'>;
  [EventTypeEnum.BROWSER_LANG_NOTICE_MODAL_KEEP]: Pick<TrackParams, 'suggested'>;
  [EventTypeEnum.CLIENT_CLICKED_PROVIDER_INTENTION_VIEW]: ClientClickedProviderIntentionViewParams;
  [EventTypeEnum.INTENTION_SETTING_PILL_CLICKED]: IntentionSettingPillClickedParams;
  [EventTypeEnum.INTENTION_MODULE_OPEN_BUTTON_CLICKED]: IntentionModuleOpenButtonClickedParams;
  [EventTypeEnum.INTENTION_EDITING_STARTED]: IntentionEditingStartedParams;
  [EventTypeEnum.INTENTION_SUBMITTED]: IntentionSubmittedParams;
  [EventTypeEnum.INTERSESSION_SECTION_TOGGLED]: IntersessionSectionToggledParams;
  [EventTypeEnum.INTERSESSION_VIEW_MEASURES_BUTTON_CLICKED]: IntersessionViewMeasuresButtonClickedParams;
  [EventTypeEnum.SAFETY_CONCERN_CONVERSATION_CLICKED]: SafetyConcernConversationClickedParams;
  [EventTypeEnum.SOFT_BLOCK_GET_STARTED_CLICKED]: SoftBlockBaseParams;
  [EventTypeEnum.SOFT_BLOCK_MEASURE_SKIPPED]: SoftBlockMeasureParams;
  [EventTypeEnum.SYSTEM_NOTIFICATION_FOR_ADMISSION_CLICKED]: SystemNotificationForAdmissionParams;
  [EventTypeEnum.SYSTEM_NOTIFICATIONS_PERMISSION_SOFT_PROMPT_DISMISSED]: SystemNotificationsPermissionParams;
  [EventTypeEnum.SYSTEM_NOTIFICATIONS_PERMISSION_ALLOWED]: SystemNotificationsPermissionParams;
  [EventTypeEnum.SYSTEM_NOTIFICATIONS_PERMISSION_DENIED]: SystemNotificationsPermissionParams;
};

export type UserClickedParams<P extends EventTypeEnum> = P extends keyof EventToClickParamsMap
  ? EventToClickParamsMap[P]
  : never;

export type EventToFormSubmittedParamsMap = {
  [EventTypeEnum.WAITING_ROOM_APPOINTMENT_UPDATED]: WaitingRoomAppointmentUpdatedParams;
  [EventTypeEnum.WAITING_ROOM_APPOINTMENT_CREATED]: WaitingRoomAppointmentCreatedParams;
  [EventTypeEnum.CLIENT_NEW_INTRO_ROOM_PII_VERIFICATION_SUBMITTED]: ClientNewIntroRoomBaseParams;
  [EventTypeEnum.PROVIDER_INTAKE_SUMMARY_ALLOCATION_RECORDED]: IntakeSummaryAllocationRecordedParams;
};

export type FormSubmittedParams<P extends EventTypeEnum> = P extends keyof EventToFormSubmittedParamsMap
  ? EventToFormSubmittedParamsMap[P]
  : never;

export type EventToInputtedParamsMap = {
  [EventTypeEnum.CLIENT_MEASURES_STARTED]: ClientMeasuresParams;
  [EventTypeEnum.SCRIBBLE_EDITED]: ScribbleEditedParams;
  [EventTypeEnum.SOFT_BLOCK_ELIGIBILITY_EVALUATED]: SoftBlockEligibilityEvaluatedParams;
  [EventTypeEnum.SOFT_BLOCK_MEASURE_COMPLETED]: SoftBlockMeasureParams;
  [EventTypeEnum.SOFT_BLOCK_AUTO_TRANSITIONED]: SoftBlockGuardrailParams;
};

export type UserInputtedParams<P extends EventTypeEnum> = P extends keyof EventToInputtedParamsMap
  ? EventToInputtedParamsMap[P]
  : never;
